import { useState } from "react";
import DashboardButton from "../../dashboard/DashboardButton";
import { FaDownload } from "react-icons/fa";
import { requestWithAuthorization } from "../../../network/apiRequests";

interface DownloadReportButtonProps {
  sessionId: string;
}

export default function DownloadReportButton({ sessionId }: DownloadReportButtonProps) {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadClick = async () => {
    if (!sessionId) {
      console.error("No session ID provided for report download");
      return;
    }

    setIsDownloading(true);
    
    try {
      const url = `${process.env.REACT_APP_API_HOSTNAME}/report/download?reportId=${encodeURIComponent(sessionId)}`;
      
      const response = await requestWithAuthorization(url, { responseType: "blob" });
      
      const blob = new Blob([response.data], { type: "application/pdf" });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", `report_${sessionId}.pdf`);
      document.body.appendChild(link);
      link.click();
      
      // Clean up
      if (link.parentNode) {
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      }
    } catch (error) {
      console.error("Error downloading report:", error);
      alert("Failed to download report. Please try again later.");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <DashboardButton
      icon={<FaDownload />}
      text={isDownloading ? "Downloading..." : "Download Report"}
      onClick={handleDownloadClick}
      disabled={isDownloading}
    />
  );
}